<template>
  <div class="bank-card page-content">
    <CustomTitleBar title="银行卡" />
    <div class="page-content">
      <div class="bank-list">
        <div class="bank-item" v-for="item in bankList" :key="item">
          <div class="bank-name">{{ item.bankName }}</div>
          <div class="bank-card-number">{{ item.bankAccountNo }}</div>
          <div class="unbind-btn" @click="handleUnbind(item)">解绑</div>
        </div>
      </div>
      <div class="add-btn">
        <van-button plain round type="primary" block class="custom-btn" @click="showAddCard">
          添加银行卡
        </van-button>
      </div>
      <div class="tips">
        <span>*说明：必须添加本人名下银行卡，一旦用户名绑定，将无法更改用户名。</span>
      </div>
    </div>

    <!-- 添加银行卡弹出层 -->
    <van-popup v-model:show="isShowPopup" position="bottom" round :style="{ height: '100%' }">
      <AddBankCard @close="closePopup" />
    </van-popup>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import CustomTitleBar from '@/components/CustomTitleBar/index.vue'
import AddBankCard from './components/AddBankCard.vue'
import { showConfirmDialog, showToast } from 'vant'
import { getCardList, unbindCard } from '@/api/wallet'
// 路由实例
const router = useRouter()

// 银行列表
const bankList = ref<any[]>()

// 控制弹出层显示
const isShowPopup = ref<boolean>(false)

// 显示添加银行卡弹层
const showAddCard = () => {
  isShowPopup.value = true
}

// 关闭弹层
const closePopup = () => {
  isShowPopup.value = false
  getList()
}

// 处理解绑银行卡
const handleUnbind = (card: any) => {
  showConfirmDialog({
    title: '提示',
    message: `确定要解绑${card.bankName}银行卡吗？`,
  })
    .then(() => {
      // TODO: 调用解绑接口
      unbindCard({ linkId: card.linkId }).then((res) => {
        if (res.code === 200) {
          showToast('解绑成功')
          getList()
        } else {
          showToast(res.msg)
        }
      })
    })
    .catch(() => {
      // 取消解绑
    })
}

// 获取银行卡列表
const getList = () => {
  getCardList().then((res) => {
    console.log('银行卡列表', res)
    if (res.code === 200) {
      bankList.value = res.data
    }
  })
}

onMounted(() => {
  getList()
})
</script>

<style lang="scss" scoped>
.page-content {
  padding-top: 44px;
}

.bank-card {
  min-height: 100vh;
  background: #fff;

  .page-content {
    padding: 20px 16px;

    .bank-list {
      margin-bottom: 40px;
    }

    .add-btn {
      padding: 0 4px;
      display: flex;
      justify-content: center;

      .custom-btn {
        width: 60%;
        height: 44px;

        // 覆盖vant默认样式
        :deep(.van-button__content) {
          font-size: 15px;
          font-weight: 400;
        }
      }
    }

    .tips {
      margin-top: 26px;
      color: #999;
      font-size: 12px;
      line-height: 17px;
      padding: 0 4px;
    }
  }
}

.bank-list {
  .bank-item {
    position: relative;
    height: 100px;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 16px;
    color: #fff;

    // 第一个卡片使用粉色渐变
    &:nth-child(odd) {
      background: #EA6D6D;
    }

    // 第二个卡片使用绿色渐变
    &:nth-child(even) {
      background: #00B578;
    }

    .bank-name {
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 50px;
    }

    .bank-card-number {
      font-size: 20px;
      letter-spacing: 2px;
    }

    .unbind-btn {
      position: absolute;
      right: 16px;
      top: 16px;
      font-size: 14px;
      color: #fff;
      padding: 4px 8px;
      border: 1px solid rgba(255, 255, 255, 0.6);
      border-radius: 4px;
      cursor: pointer;

      &:active {
        opacity: 0.8;
      }
    }
  }
}
</style>